/**
 * Copyright 2022 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 * Copyright 2023 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
export default class MqttTopics {
  // Get base URL for Backend API Calls
  static base() {
    /// \todo Refactor! There should be not wildcard at the base
    return 'umati/v2';
  }
  private static CLIENTID_WILDCARD: string = '+/+';

  static List(specificationId = '+') {
    return `${MqttTopics.base()}/+/+/list/${specificationId}`;
  }

  static FaultyList(kindOfFault = '+') {
    return `${MqttTopics.base()}/+/+/bad_list/${kindOfFault}`;
  }

  static Machine(typeDefinition: string, machineId: string) {
    /// \todo Do not "guess" the topic, get it from the machine list!
    const parts = machineId.match(/^clientId=([\w\\.:\\-]+)\|([\w\\.:\\-]+);(nsu=[\w\\.:\\-]+;[isb]=[\w\\.:\\-]+)$/);
    if (parts === null) {
      console.debug(`Invalid MachineId: ${machineId}`);
      return '';
    }
    const [, companyId, clientId, machineNodeId] = parts;
    const topic = `${MqttTopics.base()}/${companyId}/${clientId}/${typeDefinition}/${machineNodeId}`;
    return topic;
  }

  static MachinesOnline() {
    return `${MqttTopics.base()}/$Dashboard/OnlineMachines`;
  }

  static Machines(typeDefinition) {
    return `${MqttTopics.base()}/+/+/${typeDefinition}/+`;
  }
}
